export default function Root() {
    return null;
}

Root.requireAuth = true;